import {
    GET_VAT,
    GET_CURRENCY_CODE,
    GET_PAYMENT_METHOD,
    GET_PAYMENT_SUPPLEMENT,
    GET_PAYMENT_TERM,
    GET_REGION,
    GET_COUNTRY,
    GET_BANKBRANCH,
    GET_BANKNAME,
    GET_MASTER_VAT,
    GET_MR_FORM,
    GET_MR_VENDORTYPE,
    GET_MR_REF_LIST,
    GET_MR_PO_STATUS,
    GET_SLOC_WITH_PLANTS,
    GET_UNIT_UOM,
    GET_ORG_UNIT,
    MASTER_CLEAR,
    GET_RESON_EVAL,
    GET_WHT_VALIDATE,
    GET_MASTER_REJECTOPTION,
} from "../actions/actionTypes";

const initialState = {
    vats: [],
    masterRejectOption: [],
    currency_codes: [],
    payment_methods: [],
    payment_supplements: [],
    payment_terms: [],
    regions:[],
    countries:[],
    bankBranchs:[],
    bankNames:[],
    masterVats:[],
    mrForms:[],
    mrVendortypes:[],
    storage_locations :[],
    mrRefs:[],
    mrPOStatus:[],
    unit_uom :[],
    mrDatas:[],
    org_unit:[],
    mrReason:[],
    wht_validate:{},
};

function MasterRedux(state = initialState, action) {
    switch (action.type) { 
        case GET_VAT:
            return {
                ...state,
                vats: action.payload
            }
            case GET_MASTER_REJECTOPTION:
                return {
                    ...state,
                    masterRejectOption: action.payload
                }
        case GET_CURRENCY_CODE:
            return {
                ...state,
                currency_codes: action.payload
            }
        case GET_PAYMENT_METHOD:
            return {
                ...state,
                payment_methods: action.payload
            }
        case GET_PAYMENT_SUPPLEMENT:
            return {
                ...state,
                payment_supplements: action.payload
            }
        case GET_PAYMENT_TERM:
            return {
                ...state,
                payment_terms: action.payload
            }
        case GET_REGION:
            return {
                ...state,
                regions: action.payload
            }
        case GET_COUNTRY:
            return {
                ...state,
                countries: action.payload
            }
        case GET_BANKBRANCH:
            return {
                ...state,
                bankBranchs: action.payload
            }
        case GET_BANKNAME:
            return {
                ...state,
                bankNames: action.payload
            }
        case GET_MASTER_VAT:
            return{
                ...state,
                masterVats: action.payload
            }
        case GET_MR_FORM:
            return {
                ...state,
                mrForms: action.payload
            }
        case GET_MR_VENDORTYPE:
            return {
                ...state,
                mrVendortypes: action.payload
            }
        case GET_MR_REF_LIST:
            return {
                ...state,
                mrRefs: action.payload
            }   
        case GET_MR_PO_STATUS:
            return {
                ...state,
                mrPOStatus: action.payload
        }        
        case GET_SLOC_WITH_PLANTS:
            {
                return{
                    ...state,
                    storage_locations: action.payload
                }
            }
        case GET_UNIT_UOM:
            {
                return {
                    ...state,
                    unit_uom: action.payload
                }
            }
        case GET_ORG_UNIT:
            {
                return {
                    ...state,
                    org_unit: action.payload
                }
            }
        case MASTER_CLEAR:
            {
                return initialState
            }
        case GET_RESON_EVAL:
            return {
                ...state,
                mrReason: action.payload
            }   
            case GET_WHT_VALIDATE:
                return {
                    ...state,
                    wht_validate: action.payload
                }   
        default:
            return state;
    }
}

export default MasterRedux;
